// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"bf70a4f7","41":"8a06e62b","122":"747752ad","320":"dc993e14","348":"ab4eb649","415":"1820361e","457":"1820361e","721":"d4f2e808","728":"747752ad","742":"747752ad","803":"00a5ed69","851":"535a6a61","882":"d51b8e82","923":"30269fde"}[chunkId] + ".chunk.css";
};